// extracted by mini-css-extract-plugin
module.exports = {"inner":"EditorFooter_inner__1_5wZ","errorLogs":"EditorFooter_errorLogs__Ku6-K"};